import React from "react"
import ReactDOMClient from "react-dom/client"
import reportWebVitals from './reportWebVitals'

import { ThemeProvider } from "@mui/material/styles"
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon"
import { LocalizationProvider } from "@mui/x-date-pickers"

import { BrowserRouter } from "react-router-dom"
import { SnackbarProvider } from 'notistack'

import {
    i18n,
    Messages,
} from "@lingui/core"
import { I18nProvider } from '@lingui/react'

import { messages as messagesEn } from './locales/en/messages'
import { messages as messagesIt } from './locales/it/messages'

import "yup.config"

import { lightTheme } from "commons/themes"
import 'index.scss'
import App from './App'

export const theme = lightTheme

i18n.load({
  'it': messagesIt as Messages,
  'en': messagesEn as Messages,
})
i18n.activate('it')

const rootNode: HTMLElement = document.getElementById('root')!
const root: ReactDOMClient.Root = ReactDOMClient.createRoot(rootNode)
root.render(
    <I18nProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
            <BrowserRouter basename="/">
                <SnackbarProvider
                    maxSnack={5}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    hideIconVariant={false}>
                    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="it">
                        <App />
                    </LocalizationProvider>
                </SnackbarProvider>
            </BrowserRouter>
        </ThemeProvider>
    </I18nProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
